import { render, staticRenderFns } from "./LiveVt.vue?vue&type=template&id=c398bf2c&scoped=true&"
import script from "./LiveVt.vue?vue&type=script&lang=js&"
export * from "./LiveVt.vue?vue&type=script&lang=js&"
import style0 from "./LiveVt.vue?vue&type=style&index=0&id=c398bf2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c398bf2c",
  null
  
)

export default component.exports